import { BranchModel } from '../../branch/model/branch-model';
import { LocationMasterModel } from '../../location/model/location-master-model';

export class PartyDetailsBranchModel {
  id: number;
  branch: BranchModel;
  isDefaultBranch: boolean;
  location: LocationMasterModel; //creation of new Location from backend and assign here.
}
